export default function getAnnotationIdMaps({
  node,
  selectedNodes,
  regionOutlineNodeIds,
  regionOutlineNodes,
  regions,
  cellLocation,
}){

  let regionIdByAtnId = {};
  let nodeIdByAtnId = {};
  let styleByAtnId = {};

  let selectedRegionId;
  let selectedRegionOutlineId;
  let regionIdToRegionOutlineNode = {};

  regionOutlineNodeIds.forEach(roId => {
    let regionOutlineNode = regionOutlineNodes[roId];
    let { regionId } = regionOutlineNode;
    regionIdToRegionOutlineNode[regionId] = regionOutlineNode;
    let atnId = regions[regionId];
    regionIdByAtnId[atnId] = regionId;
    nodeIdByAtnId[atnId] = roId;

    if( atnId ){
      styleByAtnId[ atnId ] = {...(regionOutlineNode.style || {}),
        cursor:'pointer',
        pointerEvents:'auto',
        stroke:regionOutlineNode?.style?.borderColor,
        strokeWidth:regionOutlineNode?.style?.borderThickness,
      };


      let selected = selectedNodes?.find((item) => {
        let thatNodeId = item.nodeId;
        let thatNode = item;
        
        let eqCL = thatNode.cellLocation.every(
          (x,ii) => x === cellLocation[ii]
        );


        return eqCL && (thatNodeId === roId);
      })

      if( selected ){
        styleByAtnId[atnId].fill = "#33aaff";
        styleByAtnId[atnId].fillOpacity = "0.5";
        selectedRegionId = regionId;
        selectedRegionOutlineId = roId;
      }



    }
  })

  return {
    regionIdByAtnId,
    nodeIdByAtnId,
    styleByAtnId,
    selectedRegionId,
    selectedRegionOutlineId,
    regionIdToRegionOutlineNode
  }
}
